'use client';

import { useLanguage } from '@/contexts/LanguageContext';

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher = ({ className = '' }: LanguageSwitcherProps) => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'bs' : 'en');
  };

  return (
    <button data-component-id="src/components/common/LanguageSwitcher.tsx:17:4" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="17" data-component-file="LanguageSwitcher.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
      onClick={toggleLanguage}
      className={`relative inline-flex items-center h-9 w-16 rounded-full bg-surface border-2 border-border transition-all duration-300 hover:border-accent focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-background ${className}`}
      aria-label="Toggle language"
      title={`Switch to ${language === 'en' ? 'Bosnian' : 'English'}`}
    >
      <span data-component-id="src/components/common/LanguageSwitcher.tsx:23:6" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="23" data-component-file="LanguageSwitcher.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
        className={`inline-block h-7 w-7 transform rounded-full bg-gradient-to-br from-kinetic-teal to-orbital-accent shadow-lg transition-transform duration-300 ease-in-out ${
          language === 'bs' ? 'translate-x-7' : 'translate-x-0.5'
        }`}
      />
      <span data-component-id="src/components/common/LanguageSwitcher.tsx:28:6" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="28" data-component-file="LanguageSwitcher.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22EN%22%7D"
        className={`absolute left-2 text-xs font-semibold transition-opacity duration-300 ${
          language === 'en' ? 'opacity-100 text-accent' : 'opacity-40 text-text-secondary'
        }`}
      >
        EN
      </span>
      <span data-component-id="src/components/common/LanguageSwitcher.tsx:35:6" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="35" data-component-file="LanguageSwitcher.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22BS%22%7D"
        className={`absolute right-2 text-xs font-semibold transition-opacity duration-300 ${
          language === 'bs' ? 'opacity-100 text-accent' : 'opacity-40 text-text-secondary'
        }`}
      >
        BS
      </span>
    </button>
  );
};

export default LanguageSwitcher;